import React, { useEffect, useState } from 'react';
import './Gallery.css';
import publicAxios from '../../utils/axios/publicAxios';
import { Link } from 'react-router-dom';
// import { galleryImages } from '../../assets/exports';

const Gallery = () => {
  const [gallery, setGallery] = useState([]);

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const res = await publicAxios.get('/public/home-page-gallery');
        setGallery(res.data.gallery || []);
      } catch (error) {
        console.error('Failed to fetch gallery:', error);
      }
    };

    fetchGallery();
  }, []);

  return (
    <section className="gallery">
      <div className="gallery-wrapper">
        {gallery && gallery.length > 0 && <Link to={"/gallery"}><h2 className="gallery-section-title">Our Gallery</h2></Link>}
        <div className="gallery-grid">
          {gallery.map((item, index) => (
            <div className="gallery-item" key={index}>
              <img src={item.imageUrl} alt={item.title} />
              <div className="caption">{item.title}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;